/*************************************************************
 * WARNING: This file was automatically generated by script. *
 *************************************************************/

/* eslint-disable @typescript-eslint/no-unused-vars */

import type { CancelTokenSource } from 'axios';
import type { CallApiResult } from '@tmapy/beetlejuice-utils';
import type { QueryArgs } from '../../utils/queryArgs';
import { callApi } from '../../utils/api';
import { queryArgs } from '../../utils/queryArgs';

export type PublishsetsDestroyRequest = {} | null | undefined;
export type PublishsetsDestroyResponse = any;

export type PublishsetsDestroyQuery = {
  /**
   * ```yaml
   * in: path
   * name: id
   * schema:
   *   type: integer
   * description: A unique integer value identifying this publishset.
   * required: true
   * ```
   */
  id?: number;
};

/**
 * DELETE /dmx-server/publishsets/{id}/
 *
 * ```yaml
 * operationId: publishsets_destroy
 * description: |-
 *   {
 *   "formats": ["/dmx-server/formats/6/",
 *       "/dmx-server/formats/7/"
 *       ],
 *   "name": "jmeno",
 *   "description": "popis",
 *   "needs_approval": true,
 *   "state": "PREPARING",
 *   "tags": [
 *       "/dmx-server/publishset_tags/2/",
 *       "/dmx-server/publishset_tags/3/"
 *   ],
 *   "approver_roles": ["VYDEJ_MANAGER"],
 *   "publishset_datasets": [
 *           {"dataset": "/dmx-server/datasets/1478/",
 *            "condition": "where something!=something else",
 *            "fields": ["PORIZ_ID", "POZN_OST"]},
 *           {"dataset": "/dmx-server/datasets/1475/"}
 *
 *       ]
 *   }
 * tags:
 *   - publishsets
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const publishsetsDestroyOperation = ({ id, ...rest }: PublishsetsDestroyQuery) =>
  ({
    method: 'DELETE',
    path: `/dmx-server/publishsets/${id}/${queryArgs(rest as QueryArgs)}`,
  }) as {
    method: 'DELETE';
    path: string & { _templateUrl: '/dmx-server/publishsets/{id}/' };
  };

/**
 * DELETE /dmx-server/publishsets/{id}/
 *
 * ```yaml
 * operationId: publishsets_destroy
 * description: |-
 *   {
 *   "formats": ["/dmx-server/formats/6/",
 *       "/dmx-server/formats/7/"
 *       ],
 *   "name": "jmeno",
 *   "description": "popis",
 *   "needs_approval": true,
 *   "state": "PREPARING",
 *   "tags": [
 *       "/dmx-server/publishset_tags/2/",
 *       "/dmx-server/publishset_tags/3/"
 *   ],
 *   "approver_roles": ["VYDEJ_MANAGER"],
 *   "publishset_datasets": [
 *           {"dataset": "/dmx-server/datasets/1478/",
 *            "condition": "where something!=something else",
 *            "fields": ["PORIZ_ID", "POZN_OST"]},
 *           {"dataset": "/dmx-server/datasets/1475/"}
 *
 *       ]
 *   }
 * tags:
 *   - publishsets
 * security:
 *   - jwtAuth: []
 *   - cookieAuth: []
 * responses:
 *   '204':
 *     description: No response body
 * ```
 */
export const publishsetsDestroy = async ({
  query,
  request,
  onUploadProgress,
  cancelToken,
}: {
  query: PublishsetsDestroyQuery;
  request?: {} | null;
  onUploadProgress?: null | ((progressEvent: any) => void);
  cancelToken?: null | CancelTokenSource;
}): Promise<CallApiResult<any>> => {
  const operation = publishsetsDestroyOperation(query);
  return callApi(
    `${globalThis.DMX_CONFIG.server}${operation.path}`,
    'DELETE',
    request,
    onUploadProgress,
    cancelToken,
  );
};
